import config from "@/consoleapi/config";
import axios, {AxiosResponse, AxiosStatic} from 'axios'
import NotificationApi from "@/consoleapi/api/notification.ts";
import Vue from "vue/types/vue";

export default class Notification {

    /**
     *
     */
    protected axios: AxiosStatic;

    protected requestUri = 'https://notification.apps.pluscomm.jp/api/v1/notification';

    /**
     *
     */
    constructor() {
        this.axios = axios;
    }

    public get(): Promise<AxiosResponse> {
        return this.axios.get(this.requestUri);
    }
}